export const limitString = (str?: string, limit?: number, replaceCar?: string) => {
  if (!str) return '';
  const replaceCarFound = replaceCar || '...';
  if (!limit) return str;
  return str.length > limit ? `${str.substring(0, limit)}${replaceCarFound}` : str;
}

export const formatString = (code?: string, separator: string = ' ') => {
  if (!code) return '';
  return code.split('').reduce((acc, char, index) => {
    return acc + (index > 0 && index % 5 === 0 ? (separator): '') + char;
  }, '');
};